import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import UserBadge from "../../assets/images/svg-icons-material-io/badge_FILL0_wght400_GRAD0_opsz48.svg";
import useUserStore from "../../utils/storeApp";
import CallAPI from "../../services/apiCalls";
import AccountDetails from "./AccountDetails";
import $ from "jquery";

const DetailsMemberUser = () => {
  const navigate = useNavigate();
  const {
    userRole,
    userToken,
    setCustomerObj,
    userSession,
    setCustomerFlag,
    SetSharedObject,
    sharedObject,
  } = useUserStore((state) => ({
    setCustomerObj: state.setCustomerObj,
    userRole: state.userRole,
    userToken: state.userToken,
    setCustomerFlag: state.setCustomerFlag,
    SetSharedObject: state.SetSharedObject,
    sharedObject: state.sharedObject,
    userSession: state.userSession,
  }));

  function formatPhoneNumber(value) {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  }

  const [accountName, setAccountName] = useState("");
  const [addresses, setAddresses] = useState([]);
  const [addressType, setAddressType] = useState("");
  const [domain, setDomain] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [fax, setFax] = useState("");
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [lastLoginTime, setLastLoginTime] = useState("");
  const [specialtyType, setSpecialtyType] = useState("");
  const [classification, setClassification] = useState("");
  const [specialization, setSpecialization] = useState("");
  const [addressList, setAddressList] = useState([]);
  const [orgList, setOrgList] = useState([]);
  const [directEmailList, setDirectEmailList] = useState([]);
  const [sharedEmailList, setSharedEmailList] = useState([]);
  const [idList, setIdList] = useState([]);
  const [processing, setProcessing] = useState(false);
  const [userEditDetails, setUserEditDetails] = useState(false);
  const [directTrust, setDirectTrust] = useState(false);

  useEffect(() => {
    if (sharedObject.accountDetailsFlag) {
      getUsers(userSession.sesuser_id);
    }
    return () => {
      SetSharedObject("accountDetailsFlag", false);
    };
  }, [sharedObject.accountDetailsFlag]);

  const getUsers = async (id) => {
    setProcessing(true);
    let call = "/users/getUserById?userId=" + id;
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let det = res.data.data;
      setValues(det);
      setUserEditDetails(det.userContact);
      getCustomerDetails(det.userContact.vendorId);
      await SetSharedObject("specialties", det.userContact.specialties);
      await SetSharedObject("selectedUser", det.userContact);
      setProcessing(false);
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      setProcessing(false);
    }
    };

    const getCustomerDetails = async (vendorId) => {
        var obj = sharedObject.vendorsObj;
        for (var i = 0; i < obj.length; i++) {
            var c = obj[i];
            if (c.id === vendorId) {
                setDirectTrust(c.directTrust);
            }
        }
    }

  const setValues = (vals) => {
    var details = vals.userDet;
    var contact = vals.userContact;
    var org = vals.userOrg;
    var emails = vals.userEmails;
    setAddresses(contact.addresses);
    if (contact?.addresses[0]?.fax != null) {
      setFax(contact?.addresses[0]?.fax);
    } else {
      setFax("");
    }

    if (contact?.addresses[0]?.phone != null) {
      setPhoneNumber(contact?.addresses[0]?.phone);
    } else {
      setPhoneNumber("");
    }
    setUserName(details.userName);
    setEmail(contact.contactEmail);
    setAddressType(contact?.addresses[0]?.addressType);
    setDomain(contact.domainName);
    setLastLoginTime(contact.lastLoginTime);
    setSpecialtyType(contact?.specialties[0]?.type);
    setClassification(contact?.specialties[0]?.classification);
    setSpecialization(contact?.specialties[0]?.specialization);
    setAccountName(details.name);
    setAddressList(contact.addresses);
    var tempSharedList = [];
    var tempDirectList = [];
    for (var i = 0; i < emails.length; i++) {
      if (emails[i].userEmailTypeString == "Shared") {
        tempSharedList.push(emails[i]);
      } else {
        tempDirectList.push(emails[i]);
      }
    }
    setDirectEmailList(tempDirectList);
    setSharedEmailList(tempSharedList);
    setIdList(contact.iDs);
    setOrgList(org);
  };
  const handleEdit = () => {
    getUsers(userSession.sesuser_id);
  };
  return (
    <div className="DetailsMemberUser">
      <div
        className="modal fade"
        id="detailsMemberUserModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="DetailsDirectorySearch"
        aria-hidden="false"
      >
        <div className="modal-dialog modal-dialog-slideout">
          <div className="modal-content">
            <div className="modal-header">
              <div
                className="modal-title spacer-inline text-size3"
                id="myModalLabel"
              >
                Details
              </div>
              <button
                type="button"
                className="close"
                aria-label="Close"
                data-dismiss="modal"
              >
                {" "}
                <span aria-hidden="false">&times;</span>{" "}
              </button>
            </div>
            <form>
              <div className="modal-body">
                <div className="modal-content-body container">
                  <div className="details-header blk-clr">
                    <img
                      className="spacer-margin7"
                      src={UserBadge}
                      alt="Medical Information Icon"
                    />
                    <div className="text-size6 ft-wt blk-clr">
                      {accountName}
                    </div>
                    <div className="sp-margin1">
                      <i className="bi bi-pencil-square sp-margin5"></i>
                      <a
                        href="#"
                        onClick={(el) => {
                          $("#EditAccount").modal("show");
                          SetSharedObject("hidePermission", true);
                          el.preventDefault();
                        }}
                      >
                        Edit
                      </a>
                    </div>
                  </div>
                  <section className="field-wrapper">
                    <div>
                      <label>Address:</label>
                      <span className="sp-margin5 spacer-inline">
                        {addresses && addresses.length > 0
                          ? addresses[0].firstLine
                          : ""}
                      </span>
                      <span className="sp-margin5 spacer-inline">
                        {addresses && addresses.length > 0
                          ? addresses[0].secondLine
                          : ""}
                        ,
                      </span>
                      <span className="sp-margin5 spacer-inline">
                        {addresses && addresses.length > 0
                          ? addresses[0].city
                          : ""}
                        ,
                      </span>
                      <span className="sp-margin5 spacer-inline">
                        {addresses && addresses.length > 0
                          ? addresses[0].state
                          : ""}
                      </span>
                      <span>
                        {addresses && addresses.length > 0
                          ? addresses[0].postalCode
                          : ""}
                      </span>
                    </div>
                    <div>
                      <label>Phone:</label>{" "}
                      <span className="sp-margin5">
                        {phoneNumber
                          ? formatPhoneNumber(phoneNumber.substring(0, 10))
                          : null}
                      </span>
                      <label>Ext:</label>{" "}
                      <span className="sp-margin5">
                        {phoneNumber
                          ? phoneNumber.substring(10, phoneNumber.length)
                          : null}
                      </span>
                    </div>
                    <div>
                      <label>Fax:</label>{" "}
                      <span className="sp-margin5">
                        {phoneNumber
                          ? formatPhoneNumber(fax.substring(0, 10))
                          : null}
                      </span>
                      <label>Ext:</label>{" "}
                      <span className="sp-margin5">
                        {phoneNumber ? fax.substring(10, fax.length) : null}
                      </span>
                    </div>
                  </section>
                  <hr />
                  {/*User Info*/}
                  <section className="field-wrapper">
                    <div>
                      <label for="UserName">Username:</label>{" "}
                      <span> {userName.split("|")[0]} </span>
                      <br />
                      <label for="ContactEmail">Contact Email:</label>{" "}
                      <span className="word-set"> {email} </span>
                      <br />
                      {/*<label for="UserType">Type:</label> <span> {addressType} </span><br />*/}
                      <label for="Domain">Domain:</label>{" "}
                      <span className="word-set">{domain}</span>
                      <br />
                      <label for="Domain">Last Login:</label>{" "}
                      <span>{lastLoginTime}</span>
                      <br />
                      <label for="Domain">Direct Trust:</label>{" "}
                      <span>{directTrust ? ("Yes") : ("No")}</span>
                      <br />
                      <label for="Specialty">Specialty</label>
                    </div>
                    <div className="sub-catg">
                      <label for=" SpecialtyType">Type:</label>{" "}
                      <span> {specialtyType}</span>
                      <br />
                      <label for=" Classification">Classification:</label>{" "}
                      <span>{classification}</span>
                      <br />
                      <label for=" Specialization">Specialization:</label>{" "}
                      <span>{specialization}</span>
                    </div>
                  </section>

                  {/*Org Info*/}
                  <div className="label-divider">
                    <div className="sp-margin7 spacer-inline">
                      Organizations
                    </div>
                  </div>
                  <div className="field-wrapper o-flow">
                    <table>
                      <tr>
                        <th>Name</th>
                        <th>Role</th>
                      </tr>

                      {orgList?.map((orgItem, index) => {
                        return (
                          <tr>
                            <td className="word-set">
                              {orgItem.organizationName}
                            </td>
                            <td className={index}>{orgItem.roleName} </td>
                          </tr>
                        );
                      })}
                    </table>
                  </div>

                  {/*Direct Email Info*/}
                  <div className="label-divider">
                    <div className="sp-margin7 spacer-inline">Direct Email</div>
                  </div>
                  {directEmailList?.length <= 0 ? (
                    <div className="field-wrapper sub-catg">
                      You currently do not have any emails.
                    </div>
                  ) : (
                    <div className="field-wrapper o-flow">
                      <table>
                        <tr>
                          <th>Email</th>
                          <th>Purpose</th>
                        </tr>

                        {directEmailList?.map((emails, index) => {
                          return (
                            <tr key={index}>
                              <td className="word-set">
                                {emails.directEmailAddress}
                              </td>
                              <td className={index}>
                                {emails.emailPurposeTypeString}
                              </td>
                            </tr>
                          );
                        })}
                      </table>
                    </div>
                  )}

                  {/*Shared Emails Info*/}
                  <div className="label-divider">
                    <div className="sp-margin7 spacer-inline">
                      Assigned To Organization Email
                    </div>
                  </div>
                  {sharedEmailList?.length <= 0 ? (
                    <div className="field-wrapper sub-catg">
                      There are no org emails assigned to you.
                    </div>
                  ) : (
                    <div className="field-wrapper o-flow">
                      <table>
                        <tr>
                          <th>Email</th>
                          <th>Purpose</th>
                        </tr>
                        {sharedEmailList?.map((emails, index) => {
                          return (
                            <tr>
                              <td className="word-set">
                                {emails.directEmailAddress}
                              </td>
                              <td className={index}>
                                {emails.emailPurposeTypeString}
                              </td>
                            </tr>
                          );
                        })}
                      </table>
                    </div>
                  )}

                  {/*ID Info*/}
                  <div className="label-divider">
                    <div className="sp-margin7 spacer-inline">ID</div>
                  </div>
                  {sharedEmailList?.length <= 0 ? (
                    <div className="field-wrapper sub-catg">
                      There are currently no IDs.
                    </div>
                  ) : (
                    <div className="field-wrapper">
                      <table className="o-flow">
                        <tr>
                          <th>Type</th>
                          <th>Value</th>
                          <th>Issuing Authority</th>
                        </tr>
                        {idList?.map((id, index) => {
                          return (
                            <tr>
                              <td> {id.idTypeString} </td>
                              <td> {id.value} </td>
                              <td> {id.issuingAuthority} </td>
                            </tr>
                          );
                        })}
                      </table>
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </form>
            {processing ? <div className="loading"></div> : null}
          </div>
        </div>
      </div>
      <AccountDetails
        closeEdit={(el) => handleEdit()}
        userEditDetails={userEditDetails}
      />
    </div>
  );
};

export default DetailsMemberUser;
